<template lang="pug"> 
  v-row(no-gutters justify="center")
    v-col(cols=12 md=6).px-3.pt-3
      v-form(
        ref='form'
        @submit.prevent
      )
        v-row 
          v-col(cols=12)
            v-text-field(
              v-if="!is_need_password"
              v-model='form.current_password' 
              dense
              outlined
              hideDetails="auto"
              :disabled='editstatus'
              :rules='passwordResetRules'
              :label="$t('label.current-password')"
              :placeholder="$t('placeholder.current-password')"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append='show1 = !show1'
            )
          v-col(cols=12)
            v-text-field(
              v-model='form.new_password'
              dense
              outlined
              hideDetails="auto"
              :disabled='editstatus'
              :rules='passwordRules'
              :label="$t('label.new-password')"
              :placeholder="$t('placeholder.new-password')"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append='show2 = !show2'
            )
          v-col(cols=12)
            v-text-field(
              v-model='form.password_confirmation'
              :rules='confirmPasswordRules'
              dense
              outlined
              hideDetails="auto"
              :disabled='editstatus'
              :label="$t('label.confirm-password')"
              :placeholder="$t('placeholder.confirm-password')"
              :type="show3 ? 'text' : 'password'"
              :append-icon="show3 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append='show3 = !show3'
            )
          v-col(cols=12)
            n-btn-submit(
              v-if='editstatus' 
              @click='edit'
            ) {{ $t('button.edit') }}
            n-btn-submit(
              v-else 
              :loading='submitstatus'
              @click='submit'
            ) {{ $t('button.save') }}
</template>
<script>
import { users as apiMe } from '@/apis'  
import Validation from '@/mixins/Validations'
export default { 
  mixins: [Validation],   
  data: () => ({ 
    show1: false,
    show2: false,
    show3: false,
    submitstatus: false,
    editstatus: true, 
    form: {
      current_password: null,
      new_password: null,
      password_confirmation: null,
    },
    is_need_password: false,
  }), 
  computed: {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  async mounted () {
    this.init()
  }, 
  methods : {
    init () {
      const { is_need_password } = this.userProfile
      this.is_need_password = is_need_password
    },
    async submit () { 
      this.$ga.event('Submit', 'ChangePassword', 'SettingPage', '')  

      if(this.$refs.form.validate()) {   
        this.submitstatus = true  
        const [err, data, message] = await apiMe.updateChangePassword(this.form)
        this.submitstatus = false

        if (err) {
          this.$alert('', err, 'warning')  
          return
        } 

        this.$store.commit('userProfile/MUTATION_ME', data)
        this.init()

        this.$alert('', message, 'success')
        this.$refs.form.reset()
        this.$refs.form.resetValidation()
        this.edit()
      } 
    },
    edit () {
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.editstatus = !this.editstatus
    },
  }
}
</script>